var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.867188 4.85C0.867188 3.58988 0.867188 2.95982 1.11242 2.47852C1.32814 2.05516 1.67234 1.71095 2.09571 1.49524C2.57701 1.25 3.20707 1.25 4.46719 1.25H9.26719C10.5273 1.25 11.1574 1.25 11.6387 1.49524C12.062 1.71095 12.4062 2.05516 12.622 2.47852C12.8672 2.95982 12.8672 3.58988 12.8672 4.85V14.75L10.8047 13.25L8.92969 14.75L6.86719 13.25L4.80469 14.75L2.92969 13.25L0.867188 14.75V4.85Z",
    stroke: "#5926F0",
    strokeWidth: 1.56777,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecA);
export default __webpack_public_path__ + "static/media/rec_a.8d8ee4acf82347cce3bfac3ae55801d5.svg";
export { ForwardRef as ReactComponent };